<div class="row">
  <h3 class="col">Agentes</h3>
  
</div>

<div class="container">
  @if (agentesPaginados()?.length > 0) {
    <bn-paginacao [total]="atributosPaginacao.count"
      [tamanhoPagina]="atributosPaginacao.pageSize" [numPagina]="atributosPaginacao.page"
      [opcoesTamanhoPagina]="opcoesPaginacao" (aoMudar)="mudancaPagina($event)">
      <div class="table-responsive">
        <table class="table text-nowrap table-hover fonte">
          <thead>
            <tr>
              <th id="col-cnpj" scope="col">
                <bn-ordenacao [ordenacao]="atributosOrdenacao" [atributo]="'cnpjAgente'" [nomeAtributoExibicao]="'CNPJ'"
                  (aoClickar)="mudancaOrdenacao($event)">
                </bn-ordenacao>
              </th>
              <th id="col-nome" scope="col">
                <bn-ordenacao [ordenacao]="atributosOrdenacao" [atributo]="'nomeAgente'" [nomeAtributoExibicao]="'Nome'"
                  (aoClickar)="mudancaOrdenacao($event)">
                </bn-ordenacao>
              </th>
              <th id="col-complementar-1" scope="col">
                <bn-ordenacao [ordenacao]="atributosOrdenacao" [atributo]="'valorLimiteComplementarRecebidoPrimeiraDistribuicao'" nomeAtributoExibicao="Valor Complementar (1ª Distribuição)"
                  (aoClickar)="mudancaOrdenacao($event)">
                </bn-ordenacao>
              </th>
              <th id="col-complementar-2" scope="col">
                <bn-ordenacao [ordenacao]="atributosOrdenacao" [atributo]="'valorLimiteComplementarRecebidoSegundaDistribuicaoRealizado'" nomeAtributoExibicao="Valor Complementar (2ª Distribuição)"
                  (aoClickar)="mudancaOrdenacao($event)">
                </bn-ordenacao>
              </th>
              <th id="col-complementar-3" scope="col">
                <bn-ordenacao [ordenacao]="atributosOrdenacao" [atributo]="'valorLimiteComplementarRecebidoTerceiraDistribuicaoRealizado'" nomeAtributoExibicao="Valor Complementar (3ª Distribuição)"
                  (aoClickar)="mudancaOrdenacao($event)">
                </bn-ordenacao>
              </th>
            </tr>
          </thead>
          <tbody>
            @for (agente of agentesPaginados(); track agente.id) {
              <tr id="pointer" class="fonte" 
                [routerLink]="['/distribuicao-limites-detalhes', idCiclo(), 'agente', agente.ideAgenteModalidade]">
                <td>{{ agente.cnpjAgente | bnMask: 'CNPJ' }}</td>
                <td>{{ agente.nomeAgente }}</td>
                <td>{{ agente.valorLimiteComplementarRecebidoPrimeiraDistribuicao | bnMask: 'MOEDA' }}</td>
                <td>{{ agente.valorLimiteComplementarRecebidoSegundaDistribuicaoRealizado | bnMask: 'MOEDA' }}</td>
                <td>{{ agente.valorLimiteComplementarRecebidoTerceiraDistribuicaoRealizado | bnMask: 'MOEDA' }}</td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    </bn-paginacao>
  } @else {
    <span>Nenhum registro de distribuição para agente encontrado.</span>
  }
</div>